const Logger = require('./logger/logger').Logger;

module.exports.TimingLogger = new Logger('TimingLogger', {
  level: "TRACE", appenders:[
    // "FileAndLineTimingPingAppender",
    "TimingConsoleAppender"
  ]
});
